export default "__VITE_ASSET__BXRBseEJ__"